<template>
  <MultselectForm
    :options="options"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :internalSearch="true"
    :searchable="true"
    trackby="Id"
    label="Nome"
    :placeholder="placeholderText"
    :disabled="disabled"
    :multiple="multiple"
    :hideSelected="hideSelected"
    :showLimitText="showLimitText"
    :limit="limit"
    @change="$emit('change', $event)"
    @remove="$emit('remove', $event)"
    @open="$emit('open')"
    @close="$emit('close')"
  />
</template>

<script>
import userService from "../../helpers/user.service";

export default {
  name: "MultselectFormFranqueadoUnidade",
  emits: [
    "update:modelValue",
    "change",
    "remove",
    "open",
    "close",
  ],
  props: {
    modelValue: {
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    hideSelected: {
      type: Boolean,
      default: false,
    },
    showLimitText: {
      type: Boolean,
      default: false,
    },
    limit: {
      default: null,
    },
  },
  data() {
    return {
      options: [],
      unsubscribeUserUpdated: null,
    }
  },
  computed: {
    placeholderText() {
      return this.placeholder || this.$t('multiselect.franchiseUnitPlaceholder')
    },
  },
  created() {
    this.carregarOpcoes()
    this.aplicarUnidadePadrao()
    this.unsubscribeUserUpdated = userService.onUserUpdated(() => {
      this.carregarOpcoes()
    })
  },
  beforeUnmount() {
    if (this.unsubscribeUserUpdated)
      this.unsubscribeUserUpdated()
  },
  methods: {
    carregarOpcoes() {
      this.options = userService.getFranqueadoUnidadeOptions()
    },
    temSelecao() {
      if (this.multiple)
        return Array.isArray(this.modelValue) && this.modelValue.length > 0
      return this.modelValue != null
    },
    aplicarUnidadePadrao() {
      if (this.temSelecao())
        return

      const idPadrao = userService.getUser()?.IdFranqueadoUnidadePadrao ?? null
      const opcao = userService.findFranqueadoUnidadeOption(idPadrao)
      if (!opcao)
        return

      this.$emit('update:modelValue', this.multiple ? [opcao] : opcao)
    },
  },
}
</script>
